import { occupiedBoxSpaceForVariant } from '../utils/box-capacity';
import { isEmbroideryPersonalizationProduct } from '../multistep/embroidery-details';
import { GIFT_BOX_PRODUCT_TYPE, GIFT_CARD_PRODUCT_TYPE } from '../config';
const isGiftBoxProduct = (item)=>{
    return (item === null || item === void 0 ? void 0 : item.product_type) === GIFT_BOX_PRODUCT_TYPE;
};
const isGiftCardProduct = (item)=>{
    return (item === null || item === void 0 ? void 0 : item.product_type) === GIFT_CARD_PRODUCT_TYPE;
};
const effectiveSpaceForLine = (line)=>{
    var _line_variant_id, _ref;
    const variantId = String((_ref = (_line_variant_id = line.variant_id) !== null && _line_variant_id !== void 0 ? _line_variant_id : line.id) !== null && _ref !== void 0 ? _ref : '');
    return occupiedBoxSpaceForVariant(variantId);
};
export const buildSelectableUnits = (cartItems, giftBoxId)=>{
    const selectableItems = cartItems.filter((item)=>{
        var _item_properties;
        if (isGiftBoxProduct(item)) return false;
        if (isGiftCardProduct(item)) return false;
        if (isEmbroideryPersonalizationProduct(item)) return false;
        const parentId = (_item_properties = item.properties) === null || _item_properties === void 0 ? void 0 : _item_properties._gift_box_parent_id;
        if (!parentId) return true;
        if (giftBoxId && parentId === giftBoxId) return true;
        return false;
    });
    return selectableItems.flatMap((item)=>{
        const qty = Number(item.quantity) || 0;
        const space = effectiveSpaceForLine(item);
        var _item_title;
        return Array.from({
            length: qty
        }, (_, i)=>({
                unitKey: `${item.key}::${i}`,
                lineKey: item.key,
                index: i,
                title: (_item_title = item.title) !== null && _item_title !== void 0 ? _item_title : '',
                originalQuantity: qty,
                item,
                effectiveSpace: space
            }));
    });
};
